import React, { useState, useEffect } from "react"
import { Helmet } from "react-helmet"
import { useNavigate } from "react-router-dom"
import MasterGamesList from "../data/MasterGamesList"
import { currentDomain, currentPath } from "../Index"
import { useLocation } from "react-router-dom"
import { promotionsData } from "../data/PromotionData"
import ModuleBNGSplash from "./promotion_modules/ModuleBNGSplash"

export default function BNGSplash({ isLightMode }) {
  const [activeModal, setActiveModal] = useState("")

  const modalComponents = {
    "BNG Splash Spin Into Summer": ModuleBNGSplash,
  }

  const ActiveModal = activeModal ? modalComponents[activeModal] : null

  const handleRaceOfReels = () => {
    if (!isLoggedIn) {
      window.location.href = "/promotion"
    } else {
      setActiveModal("BNG Splash Spin Into Summer")
    }
  }

  const [isLoggedIn, setIsLoggedIn] = useState(false)
  const [isMobile, setIsMobile] = useState(false)
  const data = promotionsData.find(
    (promo) => promo.title === "BNG Splash Spin Into Summer"
  )
  const navigate = useNavigate()

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 841)
    }
    handleResize()
    window.addEventListener("resize", handleResize)
    return () => {
      window.removeEventListener("resize", handleResize)
    }
  }, [])

  useEffect(() => {
    const loggedInState = localStorage.getItem("isLoggedIn") === "true"
    setIsLoggedIn(loggedInState)
  }, [])
  const location = useLocation()
  const isAppPromo = location.pathname.startsWith("/app-promotion")

  useEffect(() => {
    const isAppPromotion = location.pathname.startsWith("/app-promotion")

    if (isAppPromotion) {
      const theme = isLightMode ? "light" : "dark"
      document.documentElement.dataset.theme = theme
      localStorage.setItem("theme", theme)
    }
  }, [location.pathname])

  //If the promo page is expired - throws error
  useEffect(() => {
    if (!data) {
      navigate("/not-found")
    }
  }, [data, navigate])

  if (!data) return null

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>BNG Splash Spin Into Summer</title>
        <link rel="icon" href="/images/fav.webp" sizes="32x32" />
        <meta name="description" content="ddd" />
        <link rel="canonical" href={`${currentDomain}${currentPath}`} />
      </Helmet>
      <div className="promotion-page-main all-page-main-container-min-height">
        <div className="promotion-page-container main-container-global-adjusted-padding">
          <div className="promotion-tnc-page">
            <div className="promotion-page-breadcrumb">
              <a
                href={
                  isAppPromo
                    ? "/promotion/".replace("/promotion", "/app-promotion")
                    : "/promotion/"
                }
              >
                Promotions
              </a>{" "}
              / <span>{data.title}</span>
            </div>
            <div className="promotion-tnc-banner">
              <img
                src={isMobile ? data.imgSrc : data.bannerSrc}
                alt={`FGH ${data.title}`}
              />
            </div>
            <div className="promotion-tnc-content">
              <div className="promotion-tnc-info">
                <div
                  className={`promotion-indication-message ${data.promotionMessage.class}`}
                >
                  {data.promotionMessage.text}
                </div>
                <h1>BNG Splash Spin Into Summer</h1>
                <h2>3,500 Free Spins Up for Grabs!</h2>
                <div className="promotion-tnc-period">
                  <strong>Promo Period: </strong>
                  <span>April 03 (12NN) - May 1 (11:59AM), 2026</span>
                </div>
              </div>
              <div className="promotion-tnc-mechanic-content">
                {isLoggedIn && !isAppPromo && (
                  <div className="promotion-tnc-btn-wrapper">
                    <button
                      className="promotion-cta-btn"
                      onClick={handleRaceOfReels}
                    >
                      Leaderboard
                    </button>
                  </div>
                )}
                <p style={{ fontSize: "16px", marginBottom: "10px" }}>
                  This summer, every winning spin you can collect SUMMER POINTS
                  for a chance to win FREE SPINS!
                </p>
                <p
                  style={{
                    fontSize: "16px",
                    marginBottom: "20px",
                    fontStyle: "italic",
                  }}
                >
                  Just Spin, Win, and Earn points!
                </p>

                <strong>Mechanics: </strong>
                <ol>
                  <li>Play any BNG slot game on our website</li>
                  <li>
                    Every spin/round that results in a win = 1 SUMMER POINT
                    <ul style={{ marginBottom: "0px" }}>
                      <li>
                        Example: If you play 120 spins and 45 of those spins
                        win, you earn 45 Summer Points. More wins = more points
                        = higher rank = bigger FREE SPINS
                      </li>
                    </ul>
                  </li>
                  <li>
                    The more winning spins you get, the higher you climb on the
                    tournament leaderboard.
                  </li>
                  <li>
                    The Top 20 players with the most Summer Points win FREE
                    SPINS
                  </li>
                  <li>
                    The promotion consists of two (2) tournaments, each running
                    for two (2) weeks
                  </li>

                  <div className="table-wrapper">
                    <table className="promotion-tnc-table">
                      <thead>
                        <tr>
                          <th>-</th>
                          <th>Cut-off Period</th>
                          <th>Awarding</th>
                          <th>Featured Game</th>
                        </tr>
                      </thead>

                      <tbody>
                        <tr>
                          <td>1st Tournament</td>
                          <td>
                            April 3 (12nn) - <br />
                            April 17 (11:59am)
                          </td>
                          <td>April 17, 2026 | 3PM</td>
                          <td>Lucky Penny 2</td>
                        </tr>
                        <tr>
                          <td>2nd Tournament</td>
                          <td>
                            April 17 (12nn) - <br />
                            May 1 (11:59am)
                          </td>
                          <td>May 1, 2026 | 3PM</td>
                          <td>Forge of Vulcan</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  {!isAppPromo && (
                    <MasterGamesList
                      qualifiedGamesOnly="on"
                      customQualifiedGames={[
                        {
                          provider: "bng",
                          gameName: "Lucky Penny 2",
                          rtpTag: "1st Tournament",
                        },
                        {
                          provider: "bng",
                          gameName: "Forge of Vulcan",
                          rtpTag: "2nd Tournament",
                        },
                      ]}
                      limit={2}
                      headerText={null}
                      linkTo={null}
                      headerTag="h2"
                    />
                  )}

                  <li>FREE SPINS can be used only on the featured game.</li>
                  <li>
                    Winnings from FREE SPINS have no rollover requirement.
                  </li>
                  <div className="table-wrapper">
                    <table className="promotion-tnc-table">
                      <thead>
                        <tr>
                          <th>Rank</th>
                          <th>Free Spins</th>
                          <th>Bet Value</th>
                        </tr>
                      </thead>

                      <tbody>
                        <tr>
                          <td>1</td>
                          <td>300</td>
                          <td>100.00</td>
                        </tr>
                        <tr>
                          <td>2</td>
                          <td>250</td>
                          <td>80.00</td>
                        </tr>
                        <tr>
                          <td>3</td>
                          <td>200</td>
                          <td>50.00</td>
                        </tr>
                        <tr>
                          <td>4-10</td>
                          <td>100</td>
                          <td>30.00</td>
                        </tr>
                        <tr>
                          <td>11-15</td>
                          <td>50</td>
                          <td>20.00</td>
                        </tr>
                        <tr>
                          <td>16-20</td>
                          <td>30</td>
                          <td>10.00</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <li>
                    FGH reserves the right to amend, extend, or terminate this
                    promotion at any time without prior notice.
                  </li>
                </ol>
                {!isAppPromo && (
                  <div className="promotion-tnc-cta">
                    <a
                      className="promotion-cta-btn"
                      href="/slots/?provider=BNG"
                    >
                      PLAY NOW
                    </a>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      {ActiveModal && <ActiveModal closeModal={() => setActiveModal("")} />}
    </>
  )
}
